const loginEnvMap = {
  prod: "https://realme.govt.nz/",
  sit: "https://sit.utilities.realme.govt.nz/",
  uat: "https://uat.utilities.realme.govt.nz/",
  ite: "https://ite.utilities.realme.govt.nz/",
};

export default loginEnvMap;
